let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5p0ab")).then(() => parcelRequire('g4I8Z'));